<template>
  <div>
    <!-- 头部横幅 -->
    <bigbg
     :url="bandat.bgImg"
    :bigtext="bandat.title"
    :smalltext="bandat.subtitle"
    ></bigbg>
 <!-- 详情页 -->
    <div v-html='pagetable'>
    </div>
   
    <!-- 引入头部底部组件 -->
    <Header></Header>
    <Footer></Footer>
  </div>
</template>
<script>
//根据id获取导航配置得接口 电子巡更 "9a627124-4a48-4448-adb6-08c89e25a8e1"
import {getlag,getpages} from '@/api/srapi/srapi.js'
import bigbg from "@/views/srdemo/component/bigbg.vue";
// 导入头部底部组件
//引入头部组件
import Header from "@/components/Header.vue";
// 引入底部组件
import Footer from "@/components/Footer.vue";
export default {
  name: "filmxun",
  components: {
    bigbg,
    Header,
    Footer,
  },
  data() {
    return {
      bandat:{},
      pagetable:null
    };
  },
 async mounted() {
   //获取页面的全部数据
   const res= await getlag("9a627124-4a48-4448-adb6-08c89e25a8e1")
   console.log(res);
   console.log(res.data.data);
   this.bandat=res.data.data
   //获取详情页
     const pages=await  getpages(this.bandat.pcUrl)
     this. pagetable=pages.data.content
     console.log(pages.data.content);

  },
};
</script>
<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>